import { useMemo } from "react";

import type { CommunityMember } from "@/react/types/CommunityMember";

import { CardView } from "../CommunityMembers/CardView/CardViewV2";
import { useCanReceiveDmBatch } from "../CommunityMembers/hooks/useCanReceiveDmBatch";
import { ListView } from "../CommunityMembers/ListView/ListViewV2";
import { VIEWS, type Views } from "../constants";

interface MembersViewProps {
  activeView: Views;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  members: CommunityMember[];
  shouldShowHiddenMemberTooltip?: boolean;
}

const MembersView = ({
  activeView,
  fetchNextPage,
  hasNextPage,
  members,
  shouldShowHiddenMemberTooltip = true,
}: MembersViewProps) => {
  const memberIds = useMemo(() => members.map(m => m.id), [members]);
  const { canReceiveDmByMemberId, isLoading: isCanReceiveDmLoading } =
    useCanReceiveDmBatch(memberIds);

  return activeView === VIEWS.CARDS ? (
    <CardView
      members={members}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      canReceiveDmByMemberId={
        isCanReceiveDmLoading ? false : (canReceiveDmByMemberId ?? false)
      }
    />
  ) : (
    <ListView
      members={members}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      shouldShowHiddenMemberTooltip={shouldShowHiddenMemberTooltip}
      canReceiveDmByMemberId={
        isCanReceiveDmLoading ? false : (canReceiveDmByMemberId ?? false)
      }
    />
  );
};

export default MembersView;
